import { render, staticRenderFns } from "./Blob.vue?vue&type=template&id=79ab7e9c&scoped=true"
import script from "./Blob.vue?vue&type=script&lang=js"
export * from "./Blob.vue?vue&type=script&lang=js"
import style0 from "./Blob.vue?vue&type=style&index=0&id=79ab7e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ab7e9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
